import React from 'react';
import { Link } from '@tanstack/react-router';
import pluralize from 'pluralize';

interface DashboardInvitationsBannerProps {
  invitations: number;
};

const DashboardInvitationsBanner: React.FC<DashboardInvitationsBannerProps> = ({ invitations }) => {
  if (invitations === 0) {
    return null;
  }

  return (
    <>
      <wa-callout variant="warning">
        You have {invitations} pending {pluralize('invitation', invitations)}.{' '}
        <Link to="/dashboard/invitations">View invitations</Link>
      </wa-callout>
    </>
  );
}

export default DashboardInvitationsBanner;
